import { Component, Input, OnInit } from '@angular/core';
import { ProgressItem, ProgressService } from '../../progress.service';
import { Subscription } from 'rxjs';
import { VrstaJoba } from '@kodit/core/data-api';

@Component({
  selector: 'kodit-progress-item',
  templateUrl: './progress-item.component.html',
  styleUrls: ['./progress-item.component.scss'],
})
export class ProgressItemComponent implements OnInit {
  @Input('progress') progressItem: ProgressItem;
  progressPercent: number;
  naziv: string;
  private _subs: Subscription = new Subscription();

  constructor(private _progressService: ProgressService) {}

  ngOnInit(): void {
    this._subs.add(
      this._progressService.getBehaviorSubjectForVrstaJoba(this.progressItem.vrstaJoba)
        .subscribe(procenat => {
          this.progressPercent = Math.round(procenat);
        })
    );
    if(this.progressItem.vrstaJoba == VrstaJoba.KREIRANJE_RACUNA){
      this.naziv = 'Automatsko kreiranje racuna od odobrenih SEF racuna'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.SINHRONIZACIJA_ULAZNIH_RACUNA){
      this.naziv = 'Sinhronizacija ulaznih računa sa SEF-om'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.IMPORT_POCETNIH_STANJA){
      this.naziv = 'Uvoz početnih stanja kupaca/dobavljača'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.IMPORT_SIFARNIKA){
      this.naziv = 'Uvoz šifarnika'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.IMPORT_IZVODA){
      this.naziv = 'Uvoz izvoda'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.SINHRONIZACIJA_ULAZNIH_EOTPREMNICA){
      this.naziv = 'Sinhronizacija ulaznih otpremnica i prijemnica sa SEF-om'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.MASOVNO_DUPLIRANJE_RACUNA){
      this.naziv = 'Masovno dupliranje računa'
    }
    if(this.progressItem.vrstaJoba == VrstaJoba.MASOVNO_SLANJE_PREDRACUNA_EMAIL){
      this.naziv = 'Masovno slanje predračuna na email'
    }
  }

  // startTour() {
  //   this._joyrideHandleService.startTutorial(this.tutorijal.steps);
  // }
}
